<!--
    描述: 在模板表单中新增字段新增(模板设置引用)
    日期: 2020.05.19
    created by yefan
-->
<template>
    <div class="add-item-page">
        <el-form ref="fieldItemForm" :model="fieldItemForm" :rules="taskItemValidate" label-width="100px"
                 class="content">
            <el-form-item label="标题" prop="title">
                <el-input v-model="fieldItemForm.title" placeholder="请输入标题" :disabled="mode == 'view'"/>
            </el-form-item>
            <el-form-item label="业务模板" prop="checkedTemplates">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" :disabled="mode == 'view'"
                             @change="handleCheckAllChange">全选
                </el-checkbox>
                <el-checkbox-group v-model="fieldItemForm.checkedTemplates" :disabled="mode == 'view'"
                                   @change="handlecheckedTemplatesChange">
                    <el-checkbox v-for="template in templates" :label="template.value" :key="template.value">
                        {{template.sname}}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="类型" prop="formType">
                <el-select v-model="fieldItemForm.formType" placeholder="请选择类型" :disabled="mode == 'view'">
                    <el-option v-for="(item) in typeList" :key="item.value" :label="item.sname"
                               :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <template v-if="fieldItemForm.formType == '1005001'"><!--数值型-->
                <el-form-item label="数值精度">
                    <el-inputNumber v-model="fieldItemForm.precision" size="large" class="w100" :min="0" :max="100"
                                    placeholder="请输入数值精度" :disabled="mode == 'view'"/>
                </el-form-item>
            </template>
            <template v-if="fieldItemForm.formType == '1005001'|| fieldItemForm.formType == '1005002'"><!--数值型-->
                <el-form-item label="后缀名">
                    <el-input v-model="fieldItemForm.suffix" placeholder="请输入后缀名" :disabled="mode == 'view'"/>
                </el-form-item>
            </template>
            <template v-if="mode!='view' && fieldItemForm.formType == '1005003'"><!--日期型-->
                <el-form-item label="日期格式">
                    <el-select v-model="fieldItemForm.dateType" placeholder="请选择日期格式" :disabled="mode == 'view'">
                        <el-option label="yyyy-MM-dd" value="date"></el-option>
                        <el-option label="yyyy-MM-dd HH:mm:ss" value="datetime"></el-option>
                    </el-select>
                </el-form-item>
            </template>
            <template v-if="mode!='view' && fieldItemForm.formType == '1005006'"><!--下拉选择框型-->
                <el-form-item :label="'下拉选项'+(index+1)" v-for="(item,index) in fieldItemForm.options"
                              :key="'fieldItemForm.options.'+index"
                              :prop="'options.' + index + '.value'"
                              :rules="{required: true, message: '不能为空', trigger: 'blur'}">
                    <el-row>
                        <el-col :span="20">
                            <el-input type="text" v-model="item.value" placeholder="请输入选项内容，不能重复"/>
                        </el-col>
                        <el-col :span="2" :offset="1">
                            <el-button @click="handleRemove(index)" icon="el-icon-delete-solid"
                                       size="small"></el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item>
                    <el-row>
                        <el-col :span="12">
                            <el-button type="dashed" long @click="handleAdd" icon="md-add">添加选项</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
            </template>
            <el-form-item :label="'下拉选项'+(index+1)" v-for="(item,index) in fieldItemForm.options"
                          :key="'fieldItemForm.options.'+index"
                          v-if="mode=='view' && fieldItemForm.formType == '1193009'"><!--下拉选择框型回显-->
                <el-input type="text" v-model="item.value" placeholder="请输入选项内容，不能重复" disabled/>
            </el-form-item>
            <template v-if="mode!='view' && (fieldItemForm.formType == '1005007'||fieldItemForm.formType == '1005008' ||fieldItemForm.formType == '1005009')">
                <!--系统码表-->
                <el-form-item label="码表类型" prop="dictionaryType">
                    <el-input disabled type="text" v-model="fieldItemForm.dictionaryTypeName" placeholder="请选择码表类型">
                        <el-button class="h40 btn-radis" type="primary" slot="append" icon="el-icon-plus"
                                   :disabled="mode == 'view'"
                                   @click="selectDictionary"></el-button>
                    </el-input>
                </el-form-item>
            </template>
            <template v-if="fieldItemForm.formType == '1005002' ||fieldItemForm.formType == '1005007'"><!--关联字段-->
                <el-form-item label="关联字段" prop="remark">
                    <tree-select v-model="fieldItemForm.relatedFields"
                                 :multiple="true"
                                 :options="publicFields"
                                 :disabled="mode == 'view'"
                                 :append-to-body="true"
                                 :limit="2"
                                 :default-expand-level="1"
                                 placeholder="请选择">
                    </tree-select>
                </el-form-item>
            </template>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="fieldItemForm.remark" type="textarea" :rows="2" :autosize="{minRows: 2,maxRows: 4}"
                          placeholder="请输入备注" :disabled="mode == 'view'"/>
            </el-form-item>
        </el-form>
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width"
                   :footer-hide='true' append-to-body>
            <dictTable ref="dictTable" v-if="dialogObj.visible" @on-selected="handleDictsSelcted"></dictTable>
        </el-dialog>
    </div>
</template>

<script>
    import {savePublicField, getFieldInfo, getRelatedFields} from '@/api/modules/analysis.js'
    import dictTable from './dict_table'
    import {mapState} from "vuex";

    export default {
        name: 'form-item-add',
        components: {dictTable},
        props: {
            fieldId: {//修改时，字段的id
                type: String,
                default: ''
            },
            mode: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                submitLoading: false,
                publicFields: [],
                fieldItemForm: {
                    id: '',
                    title: '',
                    formType: '',
                    businessType: '',
                    checkedTemplates: [],
                    precision: 0,//选择数值型的时候，需要输入的数值精度
                    dateType: 'date',//选择日期型的时候，日期格式
                    dictionaryTypeName: '',//选择系统码表型的时候，选择系统码表的类型名称
                    dictionaryType: '',//选择系统码表型的时候，选择系统码表的类型
                    suffix: "",   //后缀名
                    relatedFields: null,
                    options: [
                        {
                            value: ''
                        }
                    ],
                    remark: '',
                },
                taskItemValidate: {
                    title: [{required: true, message: '请输入标题', trigger: 'blur'}],
                    formType: [{required: true, message: '请选择类型', trigger: 'change'}],
                    checkedTemplates: [{required: true, type: 'array', message: '请选择业务模板', trigger: 'change'}],
                    dictionaryType: [{required: true, message: '请选择码表类型', trigger: 'change'}],
                },
                dialogObj: {
                    title: "选择码表",
                    visible: false,
                    closable: false,
                    width: '500px',
                },
                page: {
                    pages: 1,//总共页数
                    total: 0, // 数据总数
                    current: 1, // 当前页码
                    pageSize: 10, // 每页条数
                },
                checkAll: false,
                isIndeterminate: true
            };
        },

        methods: {
            //获取所有关联字段
            getPublicFields() {
                getRelatedFields({}).then(res => {
                    res.code == 0 ? this.publicFields = res.data : this.$message.error(res.msg)
                })
            },

            //业务模板，CheckBox勾选框，全选事件
            handleCheckAllChange(val) {
                let arr = this.templates.map(x => {
                    return x.value
                });
                this.fieldItemForm.checkedTemplates = val ? arr : [];
                this.isIndeterminate = false;
            },

            //业务模板，CheckBox勾选框，勾选改变事件
            handlecheckedTemplatesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.templates.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.templates.length;
            },

            //确定按钮事件
            doSave() {
                this.$refs.fieldItemForm.validate(valid => {
                    if (valid) {
                        this.fieldItemForm.businessType = this.fieldItemForm.checkedTemplates.join();
                        this.fieldItemForm.relatedFields = this.fieldItemForm.relatedFields;
                        let additional = {};
                        additional.precision = this.fieldItemForm.precision;
                        additional.suffix = this.fieldItemForm.suffix;
                        additional.dateType = this.fieldItemForm.dateType;
                        additional.dictionaryTypeName = this.fieldItemForm.dictionaryTypeName;
                        additional.dictionaryType = this.fieldItemForm.dictionaryType;
                        this.fieldItemForm.formType == "1005006" ? additional.options = this.fieldItemForm.options : additional.options = [];
                        this.fieldItemForm.additional = JSON.stringify(additional);
                        savePublicField(this.fieldItemForm).then(res => {
                            res.code == 0 ? this.$message.success('保存成功！') : this.$message.error(res.msg)
                            //点击确定后关闭弹框
                            this.$emit('dialogClose')
                        })
                    } else {
                        this.$message.warning('请完善必填项!')
                    }
                })
            },

            //双击字典码列表，获取字典
            handleDictsSelcted(obj) {
                this.dialogObj.visible = false;
                this.fieldItemForm.dictionaryTypeName = obj.sname;
                this.fieldItemForm.dictionaryType = obj.value;
            },

            //编辑业务字段时获取业务字段信息
            getInfos() {
                getFieldInfo({id: this.fieldId})
                    .then(res => {
                        if (res.code === 0) {
                            let _data = res.data;
                            let additional = res.data.additional;
                            this.fieldItemForm.id = _data.id;
                            this.fieldItemForm.title = _data.title;
                            this.fieldItemForm.formType = _data.formType;
                            this.fieldItemForm.precision = additional.precision;
                            this.fieldItemForm.suffix = additional.suffix;
                            this.fieldItemForm.dateType = additional.dateType;
                            this.fieldItemForm.dictionaryTypeName = additional.dictionaryTypeName;
                            this.fieldItemForm.dictionaryType = additional.dictionaryType;
                            this.fieldItemForm.options = additional.options;
                            this.fieldItemForm.relatedFields = _data.relatedFields;
                            this.fieldItemForm.remark = _data.remark;
                            this.fieldItemForm.checkedTemplates = _data.businessType.split(",")
                        }
                    });
            },

            handleAdd() {
                this.fieldItemForm.options.push({value: ''});
            },

            handleRemove(index) {
                this.fieldItemForm.options.splice(index, 1);
            },

            //选择码表类型
            selectDictionary() {
                this.dialogObj.visible = true;
            },
        },

        mounted() {
            this.mode == 'add' ? '' : this.getInfos();
            this.getPublicFields();
        },
        computed: {
            ...mapState('dict', {
                templates: state => state.ywmb, // 业务模板
                typeList: state => state.bdlx, // 表单类型
            })
        },
    }

</script>

<style lang="less" scoped>
    .add-item-page {
        padding-top: 10px;

        .content {
            height: 400px;
            margin-bottom: 20px;
            overflow: auto;
        }

        .footer {
            padding: 10px 10px 5px 10px;
            z-index: 2;
            text-align: center;
            border-top: 1px solid #e0e0e0;
            background-color: #fff;
        }
    }

    /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        vertical-align: middle;
        display: table-cell;
        position: relative;
        border: 1px solid #dcdfe6;
        padding: 0 20px;
        width: 1px;
        white-space: nowrap;
        border-left: none;
    }
</style>
